import { getContext } from '@/context';
import { MINIAPP_PACKAGE_ID } from '@/consts/configs';
import ANALYTICS_EVENT_NAMES from '@/consts/analytics';
import {
  AiGenScreenAction,
  ScreenType,
  type ClickItem,
  type AnalyticsSettings,
} from '@/types/analytics';

interface SendAiGenScreenActionOptions {
  action: AiGenScreenAction;
  screen_type: ScreenType;
  item?: ClickItem;
  settings?: AnalyticsSettings;
}

/**
 * Sends an ai_gen_screen_action analytics event.
 * Tracks user interactions within the miniapp.
 */
export function sendAiGenScreenActionAnalytics({
  action,
  screen_type,
  item,
  settings,
}: SendAiGenScreenActionOptions): void {
  try {
    const params = {
      package_id: MINIAPP_PACKAGE_ID,
      action,
      screen_type,
      ...(item && { item }),
      ...(settings && { settings }),
    };

    getContext().handlers.sendAnalytics({
      eventName: ANALYTICS_EVENT_NAMES.AI_GEN_SCREEN_ACTION,
      params,
    });
  } catch {
    // Failed to send analytics
  }
}
